import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './wtaetigkeit.list-view.html',
    styleUrls: ['./wtaetigkeit.list-view.scss']
})
export class WtaetigkeitListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
